
import Reports from "./reports";

const ModuleName = "tfApp.open-trader";

export default angular.module(ModuleName, [Reports(ModuleName)])
                      .name;
